<template>
  <v-container fluid id="investmentContainer" class="maxWidthSet px-0">
    <InvestmentsCardTitle />
    <v-card>
      <LoadingIndicator v-if="!investmentsLoading" :loading="investmentsLoading" />
      <OnexAlert
        v-if="!customerStore.investments.isCompliant"
        :type="Notifications.error"
        :value="true"
      >
        {{ $t('L_investments_accounts_not_available') }}
      </OnexAlert>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <!-- ! TOP PART -->
            <InvestmentsSummary v-if="hasInvestments" />
            <NoInvestmentsTop v-else />
          </v-col>
          <v-col cols="12">
            <!-- ! BOTTOM PART -->
            <RetirementTracker v-if="hasCalculator" />
            <NoInvestmentsBottom v-else />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import LoadingIndicator from '@/components/LoadingIndicator.vue';
import InvestmentsCardTitle from './components/InvestmentsCardTitle.vue';
import InvestmentsSummary from './components/InvestmentsSummary.vue';
import NoInvestmentsTop from './components/NoInvestmentsTop.vue';
import NoInvestmentsBottom from './components/NoInvestmentsBottom.vue';
import RetirementTracker from './components/RetirementTracker.vue';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { mapStores } from 'pinia';
import { $t } from '@/i18n/i18n.ts';
import { Notifications, OnexAlert } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'InvestmentsCard',
  components: {
    InvestmentsCardTitle,
    InvestmentsSummary,
    NoInvestmentsTop,
    NoInvestmentsBottom,
    RetirementTracker,
    LoadingIndicator,
    OnexAlert,
  },
  data() {
    return { Notifications };
  },
  computed: {
    ...mapStores(useCustomerStore),
    hasInvestments() {
      return (this.customerStore.investments.summary?.totalValue ?? 0) > 0;
    },
    investmentsLoading() {
      return this.customerStore.loading.investments;
    },
    hasCalculator() {
      return (
        (this.customerStore.investments.calculator?.projection?.percentRetirementIncomeGoal ??
          -1) >= 0
      );
    },
  },
  methods: {
    $t,
  },
  async created() {
    if (!this.hasInvestments) {
      await this.customerStore.getInvestments();
    }
  },
};
export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.maxWidthSet {
  max-width: 1024px;
  margin: auto;
}
.bottom {
  background: #d6d6d6;
}
</style>
